import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import { useParams, Navigate } from 'react-router-dom';

import { GilmoreHealthBanner, Loader } from '@/components';
import ClassAttendanceList from '@/components/classAttendance/ClassAttendanceList';
import { Layout } from '@/containers/Layout';
import { isAttendanceListingEnabled } from '@/data/useAttendanceManagement';
import { useClassroomData } from '@/data/useClassroomData';
import { useGetLearningActivity } from '@/data/useLearningActivity';
import { paths } from '@/routing/paths';
import { useFlags } from '@/utils';
import { classDetailPageBreadcrumb, classesPageBreadcrumb } from '@/utils/breadcrumbs';

import attendancePageMessages from './ClassAttendancePage.messages';

const ClassAttendancePage = () => {
    const { classroomId } = useParams();
    const { formatMessage } = useIntl();
    const { attendanceMarking } = useFlags();
    const { classData } = useClassroomData(classroomId, {
        withConsistencyRetry: true,
        withInstructors: false,
    });
    const { data: learnerActivity } = useGetLearningActivity(classData);
    const enableAttendanceMarking = isAttendanceListingEnabled(learnerActivity);

    return attendanceMarking ? (
        <Layout
            breadcrumbItems={[
                classesPageBreadcrumb(formatMessage),
                classDetailPageBreadcrumb(formatMessage, classroomId),
                {
                    text: 'Attendance',
                    href: paths.classEditPage(classroomId),
                },
            ]}
        >
            <Helmet>
                <title>{formatMessage(attendancePageMessages.pageTitle)}</title>
            </Helmet>
            <GilmoreHealthBanner />

            <Loader isLoading={!enableAttendanceMarking}>
                <ClassAttendanceList classroom={classData} learningActivity={learnerActivity} />
            </Loader>
        </Layout>
    ) : (
        <Navigate replace to={paths.root} />
    );
};

export default ClassAttendancePage;
